import { Pipe, PipeTransform } from '@angular/core';

import { MarkdownService } from '../services/shared/markdown.service';

/**
 * Pure pipe wrapper for `MarkdownService`. Used in the AI assistant chat
 * to convert streamed assistant content into safe HTML for `[innerHTML]`.
 *
 * Pass `'streaming'` as an argument while the bubble is still receiving
 * deltas — the service buffers parsing at the last paragraph break so we
 * don't flash broken HTML for in-flight markdown (mid-table, half-list,
 * unclosed `**bold`). Pass nothing (or anything else) once the stream
 * has completed and we can safely parse the full grammar.
 *
 * The pipe is pure: Angular memoizes on `(value, mode)` identity, so
 * 20-delta-per-second streams don't cause a re-parse-per-CD-pass storm
 * across every assistant bubble in the conversation.
 */
@Pipe({
    name: 'markdown',
    standalone: true,
})
export class MarkdownPipe implements PipeTransform {
    constructor(private readonly _markdown: MarkdownService) {}

    transform(value: string | null | undefined, mode: 'streaming' | 'final' = 'final'): string {
        if (!value) {
            return '';
        }
        return mode === 'streaming'
            ? this._markdown.formatStreamingMessage(value)
            : this._markdown.formatMessage(value);
    }
}
